const removeActPrefix = (value: string | undefined, withoutSpace = false): string =>
  withoutSpace
    ? value?.replace('Act', '').replace('ACT', '') || ''
    : value?.replace('Act ', '').replace('ACT ', '') || '';

export default removeActPrefix;
